import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";
class BlformService {
  async fetch(page, perPage, search) {
    const pageParam = `page=${page}&perPage=${perPage}`
    let params = search ? `search=${search}` : pageParam;

    const response = await ajaxService.get(
      `/bl-forms?${params}`
    );
    if (response.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async view(id) {
    const response = await ajaxService.get(`/bl-forms/${id}`);
    if (response.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async createForm(data) {
    const response = await ajaxService.post(`/bl-forms`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async updateForm(id, data) {
    const response = await ajaxService.put(`/bl-forms/`, id, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async deleteForm(id) {
    const response = await ajaxService.delete(`/bl-forms/`, id);
    if (response.success ?? false) {
      return response;
    }
  }

  async sendToGlobex(id) {
    const response = await ajaxService.get(`/bl-forms/send/${id}`);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }


}
const blformService = new BlformService();
export default blformService;
